import axios from '@core_utils/api/_axios.js'
import Vue from 'vue'

const attachments = {
    namespaced: true,
    state: {
        attachments: [],
        prev_attachments: {},
        is_loading_attachments_list: false,
        is_loading_add_attachment: false, // 첨부파일 업로드 로딩 state
        is_loading_delete_attachment: false, // 첨부파일 삭제 state
        is_loading_link_attachment: false // 첨부파일 문항 연결/해제 로딩 state
    },
    getters: {
        is_loading_global_disabled(state) {
            return state.is_loading_attachments_list
                || state.is_loading_add_attachment
                || state.is_loading_delete_attachment
                || state.is_loading_link_attachment
        },
        get_attatchments(state) {
            const mapAttachments = {}
            state.attachments.forEach(attachment => {
                mapAttachments[attachment.id] = attachment
            })
            return Object.values(mapAttachments).sort((a, b) => {
                // !!b.sub_list && !!a.sub_list && new Date(b.created_at) - new Date(a.created_at)
                return b.id - a.id
            })
        },
        has_attatchments(state) {
            return state.attachments !== null
        },
        get_prev_attachments: (state) => (campaign_id, company_id, sub_code) => {
            const key = `${campaign_id}-${company_id}-${sub_code}`
            if (state.prev_attachments[key])
                return state.prev_attachments[key]
            return []
        },
    },
    mutations: {
        updateAttachments(state, {method, data}) {
            if (method == 'init') {
                state.attachments = [...data]
            } else if (method === 'create') {
                let _new_attachments = [...data].map(attch => ({...attch, sub_list: []}))
                state.attachments.push(..._new_attachments)
            } else if (method === 'delete') {
                const deleted_attachment_list = data
                const _deleted_attachment_list_ld = deleted_attachment_list.map(({id}) => id)
                
                state.attachments = state.attachments.reduce((_attachments, attachmt) => {
                    if (!_deleted_attachment_list_ld.includes(attachmt.id)) {
                        _attachments.push(attachmt)
                    }
                    
                    return _attachments
                }, [])
            } else if (method === 'link') {
                const {attachment_list, sub_id, sub_code} = data
                const attachment_list_ld = attachment_list.map(({id}) => id)
                
                state.attachments = state.attachments.reduce((_attachments, attachmt) => {
                    if (attachment_list_ld.includes(attachmt.id)) {
                        if (!attachmt.sub_list.length) {
                            attachmt.sub_list.push({id: sub_id, sub_code})
                        } else {
                            if (!attachmt.sub_list.find(({id}) => id === sub_id)) {
                                attachmt.sub_list.push({id: sub_id, sub_code})
                            }
                        }
                    }
                    
                    _attachments.push(attachmt)
                    return _attachments
                }, [])
            } else if (method === 'unlink') {
                const {attachment_list, sub_id} = data
                const attachment_list_ld = attachment_list.map(({id}) => id)
                
                state.attachments = state.attachments.reduce((_attachments, attachmt) => {
                    if (!attachment_list_ld.includes(attachmt.id)) {
                        if (attachmt.sub_list.length) {
                            const _attachmt_sub_idx = attachmt.sub_list.findIndex(({id}) => id === sub_id)
                            if (_attachmt_sub_idx > -1) {
                                attachmt.sub_list.splice(_attachmt_sub_idx, 1)
                            }
                        }
                    }
                    
                    _attachments.push(attachmt)
                    return _attachments
                }, [])
            }
        },
        updateSubAttachments(state, {data, method}) {
            const {attachment_list, sub_id, sub_code, inner_storage} = data
            const attachment_list_ld = attachment_list.map(({id}) => id)
            
            if(method === 'link') {
                state.attachments = state.attachments.reduce((_attachments, attachmt) => {
                    if (attachment_list_ld.includes(attachmt.id)) {
                        inner_storage.forEach((item) => {
                            const {storage_id, sub_path} = item
                            if (!attachmt.sub_list.length) {
                                attachmt.sub_list.push({id: sub_id, sub_code, sub_path, storage_id})
                            } else {
                                if (!attachmt.sub_list.find((elem) => elem.id === sub_id && elem.sub_path === sub_path)) {
                                    attachmt.sub_list.push({id: sub_id, sub_code, sub_path, storage_id})
                                }
                            }
                        })
                    }
                    _attachments.push({
                        ...attachmt,
                    })
                    return _attachments
                }, [])
            }
            else if(method === 'unlink') {
                state.attachments  = state.attachments.reduce((_attachments, attachmt) => {
                    if (!attachment_list_ld.includes(attachmt.id)) {
                        if (attachmt.sub_list.length) {
                            for (let i = 0; i < attachmt.sub_list.length; i++) {
                                if (attachmt.sub_list[i].id === sub_id) {
                                    attachmt.sub_list.splice(i, 1)
                                    i--;
                                }
                            }
                        }
                    }
                    
                    _attachments.push(attachmt)
                    return _attachments
                }, [])
            }
        },
        initAttachmentsStorage(state) {
            state.attachments = []
            state.is_loading_add_attachment = false
            state.is_loading_delete_attachment = false
            state.is_loading_attachments_list = false
        },
        updatePrevAttachments(state, {campaign_id, company_id, sub_code, data}) {
            const key = `${campaign_id}-${company_id}-${sub_code}`
            Vue.set(state.prev_attachments, key, data)
        },
        deletePrevAttachments(state) {
            state.prev_attachments = {}
        }
    },
    actions: {
        async getAttatchments({state, commit}, {company_id, campaign_id}) {
            try {
                state.is_loading_attachments_list = true
                
                const _res_attachements = await axios.get('/attachment', {
                    params: {
                        company_id, campaign_id, with_sub_list: true
                    }
                })
                
                commit('updateAttachments', {method: 'init', data: _res_attachements.data})
            } catch (error) {
                return Promise.reject(error)
            } finally {
                state.is_loading_attachments_list = false
            }
        },
        async getPrevSubsAttachments({state, commit}, {campaign_id, company_id, sub_code}) {
            const key = `${campaign_id}-${company_id}-${sub_code}`
            if (state.prev_attachments[key]) {
                return state.prev_attachments[key]
            } else {
                commit('updatePrevAttachments', {campaign_id, company_id, sub_code, data: []})
            }
            
            const {data} = await axios.get('/attachment', {
                params: {
                    campaign_id: campaign_id,
                    company_id: company_id,
                    sub_code: sub_code,
                }
            })
            const result = data.map(({id, attachment_type, filename}) => {
                if (attachment_type === "file") {
                    return {id, type: attachment_type, filename, file_link: null}
                } else {
                    return {id, type: attachment_type, filename, file_link: filename}
                }
            })
            
            commit('updatePrevAttachments', {campaign_id, company_id, sub_code, data: result})
            
            return result
        },
        clearPrevAttachments({commit}) {
            commit('deletePrevAttachments')
        },
        async uploadAttachments({state}, {company_id, campaign_id, uploadAttchmts}) {
            try {
                state.is_loading_add_attachment = true
                
                const formData = new FormData()
                formData.append('company_id', company_id)
                formData.append('campaign_id', campaign_id)
                
                let _uploadsAttchmt_file = uploadAttchmts.filter(({type}) => type === 'file')
                let _uploadsAttchmt_url = uploadAttchmts.filter(({type}) => type === 'url')
                
                
                if (_uploadsAttchmt_file.length) {
                    _uploadsAttchmt_file.forEach(({file}) => formData.append('file', file));
                }
                
                if (_uploadsAttchmt_url.length) {
                    formData.append('url', _uploadsAttchmt_url.map(({url}) => url).join(','));
                }
                
                const _res_upload_attachements = await axios.post('/attachment', formData)
                let _new_attachments = [..._res_upload_attachements.data].map(attch => ({...attch, sub_list: []}))
                state.attachments.push(..._new_attachments)
                
                return _new_attachments
            } catch (error) {
                return Promise.reject(error)
            } finally {
                state.is_loading_add_attachment = false
            }
        },
        async linkAttachments({state, commit}, {company_id, campaign_id, sub_id, storage_id, sub_code, inner_storage}) {
            try {
                state.is_loading_link_attachment = true
                const _res_uploaded = await axios.post('/attachment/link', {
                    company_id, campaign_id, sub_id, storage_id, inner_storage
                })
                // inner_storage가 null이 아닌 경우, 선택지 첨부파일 업데이트 처리
                if (inner_storage != null) {
                    commit('updateSubAttachments', {
                        method: 'link',
                        data: {
                            ..._res_uploaded.data,
                            sub_id,
                            inner_storage,
                            sub_code,
                        },
                        
                    })
                } else {
                    commit('updateAttachments', {method: 'link', data: _res_uploaded.data})
                }
            } catch (error) {
                return Promise.reject(error)
            } finally {
                state.is_loading_link_attachment = false
            }
        },
        async unlinkAttachments({state, commit}, {company_id, campaign_id, sub_id, storage_id, inner_storage}) {
            try {
                state.is_loading_link_attachment = true
                
                const _res_unlink_attachements = await axios.delete('/attachment/link', {
                    data: {
                        company_id, campaign_id, sub_id, storage_id, inner_storage
                    }
                })
                
                // inner_storage가 null이 아닌 경우, 선택지 첨부파일 업데이트 처리
                if (inner_storage != null) {
                    commit('updateSubAttachments', {method: 'unlink', data: _res_unlink_attachements.data})
                } else {
                    commit('updateAttachments', {method: 'unlink', data: _res_unlink_attachements.data})
                }
                
            } catch (error) {
                return Promise.reject(error)
            } finally {
                state.is_loading_link_attachment = false
            }
        },
        async deleteAttachments({state, commit}, {company_id, campaign_id, storage_id}) {
            try {
                state.is_loading_delete_attachment = true
                
                const _res_deleted_attachements = await axios.delete('/attachment', {
                    data: {
                        company_id, campaign_id, storage_id
                    }
                })
                
                commit('updateAttachments', {method: 'delete', data: _res_deleted_attachements.data})
            } catch (error) {
                return Promise.reject(error)
            } finally {
                state.is_loading_delete_attachment = false
            }
        }
    }
}


export default attachments
